import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "custom-solo-bar-graph"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"50px"} }, null, -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "customValuesGraph row cs-accordion-anchor-child" }
const _hoisted_5 = {
  class: "customValuesGraphLabel",
  style: {"line-height":"1","display":"flex","align-items":"center","color":"#404040"}
}
const _hoisted_6 = { class: "customValuesGraphArea" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"customValuesCutoff\" style=\"right:0%;\"></div><div class=\"customValuesCutoff\" style=\"right:25%;\"></div><div class=\"customValuesCutoff\" style=\"left:50%;\"></div><div class=\"customValuesCutoff\" style=\"left:25%;\"></div><div class=\"customValuesCutoff\" style=\"left:0%;\"></div>", 5)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-sm-7 text-xs-center text-sm-left" }
const _hoisted_15 = { class: "col-sm-5 text-left" }
const _hoisted_16 = { style: {"font-size":"20px"} }
const _hoisted_17 = { style: {"font-size":"20px"} }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"customValuesGraphXAxis\"><div class=\"customValuesGraphXAxisLabels\"><div class=\"customValuesGraphXAxisLabel\" style=\"left:75%;width:25%;\"> Highly characteristic </div><div class=\"customValuesGraphXAxisLabel\" style=\"left:50%;width:25%;\"> More characteristic </div><div class=\"customValuesGraphXAxisLabel\" style=\"left:25%;width:25%;\"> Less characteristic </div><div class=\"customValuesGraphXAxisLabel\" style=\"left:0%;width:25%;\"> Not characteristic </div></div></div>", 1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { style: {"text-align":"center","margin-top":"3rem"} }, "Compared to your colleague ratings", -1)

import { inject, ref, computed, watch } from "vue";
import type { Ref } from "vue";
import { Tooltip } from "uiv";
import { CustomSoloReportApiModel } from "../../api-models";
import CustomRow from "./custom-row.interface";


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-solo-bar-graph',
  setup(__props) {

const report = inject("report") as Ref<CustomSoloReportApiModel>;

const values = inject("values") as Ref<string[] | undefined>;

const activeRowId = ref("");

function startingActiveRow(rows: CustomRow[]): void {
  activeRowId.value =
    rows.find((row) => row.self === Math.max(...rows.map((r) => r.self)))?.id ?? "";
}

function click(row: CustomRow): void {
  activeRowId.value = row.id === activeRowId.value ? "" : row.id;
}

function bar(start: number, end: number): string {
  return `position: absolute;
    left: ${start}%;
    right: ${end}%;
    width: ${end - start}%;
    border-top-width: 50%;
    height: 50%;
    top: 5px;
    `;
}

function marker(x: number): string {
  const size = 50;

  return `position: absolute;
    left: ${x}%;
    width: 10px;
    background: white;
    border-width: 5px;
    height: ${size}px;
    top: 0;
    color: #404040
    `;
}

function tooltip(quartile: number): string {
  switch (quartile) {
    case 1:
      return "25% of people rate themselves in this lower range";
    case 2:
      return "25% of people rate themselves in this lower-mid range";
    case 3:
      return "25% of people rate themselves in this upper-mid range";
    case 4:
      return "25% of people rate themselves in this upper range";
    case 5:
      return "You rated yourself here";
    default:
      return "";
  }
}

function score(name: string): CustomRow {
  const statsForItem = report.value?.customStatistics.soloItems.find((i) => i.title.includes(name));
  const q1 = Math.round(statsForItem?.lowerQuartile ?? 0);
  const median = statsForItem?.median ?? 0;
  const q3 = Math.round(statsForItem?.upperQuartile ?? 0);
  const min = statsForItem?.min ?? 0;
  const max = statsForItem?.max ?? 0;
  const self =
    report.value?.userValues.ratings.find((i) => i.metadata.title === name)?.rawRating ?? 0;
  const mean = Math.round(statsForItem?.mean ?? 0);

  return {
    id: name,
    shortTitle: name,
    content: `${values.value?.find((v) => v.includes(name)) ?? name}`,
    min,
    mean,
    q1,
    median,
    q3,
    max,
    self,
  };
}

const rows = computed(() => {
  if (!report.value) {
    return [];
  }

  const ratingRows: CustomRow[] = report.value.userValues.ratings.map((rating) =>
    score(rating.metadata.title),
  );

  startingActiveRow(ratingRows);
  return ratingRows;
});

return (_ctx: any,_cache: any) => {
  return (_unref(report) && _unref(values))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
            return (_openBlock(), _createElementBlock("div", {
              key: row.id,
              class: _normalizeClass(row.id)
            }, [
              _createElementVNode("a", {
                class: "a-block customValuesGraphRowAnchor cs-accordion-anchor",
                href: "javascript:void(0)",
                onClick: ($event: any) => (click(row))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, _toDisplayString(row.shortTitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_unref(Tooltip), {
                      text: tooltip(1)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle(bar(row.min, row.q1)),
                          class: "valueGraphBar q1"
                        }, null, 4)
                      ]),
                      _: 2
                    }, 1032, ["text"]),
                    _createVNode(_unref(Tooltip), {
                      text: tooltip(2)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle(bar(row.q1, row.median)),
                          class: "valueGraphBar q2"
                        }, null, 4)
                      ]),
                      _: 2
                    }, 1032, ["text"]),
                    _createVNode(_unref(Tooltip), {
                      text: tooltip(3)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle(bar(row.median, row.q3)),
                          class: "valueGraphBar q3"
                        }, null, 4)
                      ]),
                      _: 2
                    }, 1032, ["text"]),
                    _createVNode(_unref(Tooltip), {
                      text: tooltip(4)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle(bar(row.q3, row.max)),
                          class: "valueGraphBar q4"
                        }, null, 4)
                      ]),
                      _: 2
                    }, 1032, ["text"]),
                    _createVNode(_unref(Tooltip), {
                      text: tooltip(5)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          style: _normalizeStyle(marker(row.self)),
                          class: "valueGraphBar"
                        }, null, 4)
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ])
                ])
              ], 8, _hoisted_3),
              _createElementVNode("div", {
                class: _normalizeClass([{ hidden: row.id !== activeRowId.value }, "customValuesGraphInfo cs-accordion-panel"])
              }, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("p", _hoisted_14, _toDisplayString(row.content), 1),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(row.self) + " - Your rating", 1),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(row.mean) + " - Average of colleague ratings", 1)
                  ])
                ])
              ], 2)
            ], 2))
          }), 128)),
          _hoisted_18
        ]),
        _hoisted_19
      ]))
    : _createCommentVNode("", true)
}
}

})